import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import "./ScrollToTop.scss";
const ScrollToTop = () => {
    const [isButton, setIsButton] = useState(false);
    const [darkVariant, setDarkVariant] = useState(false);
    const executeScroll = () => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    };
    const handleScroll = () => {
        const positionToColorChange = document.getElementsByClassName("footer__extended-footer")[0].getBoundingClientRect().top +
            window.scrollY -
            window.innerHeight +
            135;
        window.scrollY < 200 ? setIsButton(false) : setIsButton(true);
        window.scrollY < positionToColorChange ? setDarkVariant(false) : setDarkVariant(true);
    };
    useEffect(() => {
        window.addEventListener("scroll", handleScroll);
    }, []);
    return isButton ? (_jsx("button", { onClick: executeScroll, className: `scroll-to-button ${darkVariant ? "scroll-to-button__dark" : ""}`, children: _jsx("img", { src: "/content/dam/ploom/common/chevron-dropdown.svg", alt: "" }) })) : null;
};
export default ScrollToTop;
//# sourceMappingURL=ScrollToTop.js.map